import { useMutation } from '@apollo/client'
import { ONBOARDING_STATUS_QUERY } from 'src/api/onboarding/queries/onboardingStatus'
import {
  SET_USER_DOWNLOAD_APP_MUTATION,
  SetUserDownloadAppData
} from 'src/api/onboarding/mutations/setUserDownloadApp'

interface SetUserDownloadAppVariables {
  appVersion?: string
  active: boolean
}

export function useSetUserDownloadApp({
  onCompleted,
  onError
}: {
  onCompleted?: (data: SetUserDownloadAppData) => void
  onError?: (error: any) => void
} = {}) {
  const [setUserDownloadApp, rest] = useMutation<SetUserDownloadAppData>(
    SET_USER_DOWNLOAD_APP_MUTATION,
    {
      onCompleted,
      onError,
      refetchQueries: [
        {
          query: ONBOARDING_STATUS_QUERY
        }
      ]
    }
  )

  return {
    setUserDownloadApp: (variables: SetUserDownloadAppVariables) =>
      setUserDownloadApp({ variables }),
    ...rest
  }
}
